export default {
  install(app) {
    app.config.globalProperties.$test = 'test'
  },
}
